import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import {IDateRangeVehicleReportParameters} from "../../models/reports/i-date-range-vehicle-report-parameters";
import {AppConfig} from "../../config/appconfig";
import {BaseService} from "../base-service";
import {Observable} from "rxjs/Observable";
import {Storage} from "@ionic/storage";

/*
  Generated class for the ReportPassFlowProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ReportPassFlowProvider extends BaseService{

  private readonly _url: string = AppConfig.apiBaseUrl + "report/passflow";

  constructor(
    public http: Http,
    public storage: Storage
  ) {
    super(http, storage);
  }

  public build(p: IDateRangeVehicleReportParameters): Observable<any[]>{
    let reportUtl = this._url + "/build";
    return this.http.post(reportUtl, p, {headers: this.headers})
      .map((res: Response) => {
        let data = res ? res.json() : null;
        return data ? data.checkResult : null;
    });
  }

  public getPassFlowValues(p: IDateRangeVehicleReportParameters): Observable<any[]>{
    let reportUtl = this._url + "/values";
    return this.http.post(reportUtl, p, {headers: this.headers})
      .map((res: Response) => {
        let data = res ? res.json() : null;
        return data ? data.checkResult : null;
      });
  }

  public getPassFlowOnVehicles(p: IDateRangeVehicleReportParameters): Observable<any[]> {
    let reportUtl = this._url + "/onvehicles";
    return this.http.post(reportUtl, p, { headers: this.headers })
      .map((res: Response) => {
        let data = res ? res.json() : null;
        return data ? data.checkResult : null;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/report-pass-flow/report-pass-flow.ts